export default __webpack_public_path__ + "static/media/Paradigm.87f2e2cd.jpg";